module.exports = __webpack_public_path__ + "static/media/dollar.c9ea4d3e.svg";